// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PublicCommitteePage_wrapper__2Nm2v","sidebar":"PublicCommitteePage_sidebar__UmO2B"};